import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import randomBytes from "randombytes";
export const TRANSCTION_UPDATE_ERROR = "this_entry_is_from_a_locked_period";

export interface TransactionState {
  sliderTransactions: { transactionId: string; animationId: string }[];
  silderAccordionValue: string[];
  selectedTransactionIds: string[];
  transactionLockedModal: boolean;
}

const initialState: TransactionState = {
  sliderTransactions: [],
  silderAccordionValue: ["INVOICE_AND_MEMO", "COMMENT"],
  selectedTransactionIds: [],
  transactionLockedModal: false,
};

export const transactions = createSlice({
  name: "transactions",
  initialState,
  reducers: {
    openSlider: (state, action: PayloadAction<string>) => {
      const isAlreadyOpen = state.sliderTransactions.find(
        ({ transactionId }) => transactionId === action.payload
      );

      if (isAlreadyOpen) {
        state.sliderTransactions = [
          ...state.sliderTransactions.filter(
            ({ transactionId }) => transactionId !== action.payload
          ),
          {
            transactionId: action.payload,
            animationId: randomBytes(10).toString("hex"),
          },
        ];
      } else {
        state.sliderTransactions = [
          ...state.sliderTransactions,
          {
            transactionId: action.payload,
            animationId: randomBytes(10).toString("hex"),
          },
        ];
      }
    },

    closeSlider: (state, action: PayloadAction<string>) => {
      state.sliderTransactions = state.sliderTransactions.filter(
        ({ transactionId }) => transactionId !== action.payload
      );
      state.silderAccordionValue = [];
    },

    setSilderAccordionValue: (
      state,
      action: PayloadAction<TransactionState["silderAccordionValue"]>
    ) => {
      state.silderAccordionValue = action.payload;
    },

    setSelectedTransactionIds: (
      state,
      action: PayloadAction<TransactionState["selectedTransactionIds"]>
    ) => {
      state.selectedTransactionIds = action.payload;
    },

    onTransactionUpdateFailure: (state, action: PayloadAction<string>) => {
      if (action.payload === TRANSCTION_UPDATE_ERROR) {
        state.transactionLockedModal = true;
      }
    },

    closeTransactionLockedModal: (state) => {
      state.transactionLockedModal = false;
    },
  },
});

export const {
  openSlider,
  closeSlider,
  setSilderAccordionValue,
  setSelectedTransactionIds,
  closeTransactionLockedModal,
  onTransactionUpdateFailure,
} = transactions.actions;

export default transactions.reducer;
